import { memo } from "react";
import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
const SvgCertificate = (props: SvgProps) => (
  <Svg width={32} height={32} fill="none" {...props}>
    <Path
      fill="#E8527B"
      d="M28.46 20.306a.72.72 0 0 0-.002-.663l-.995-1.394a.15.15 0 0 1-.03-.09c0-.05.011-.064.03-.09l.997-1.398a.72.72 0 0 0-.002-.664.8.8 0 0 0-.191-.288.8.8 0 0 0-.3-.185l-1.709-.601a.2.2 0 0 1-.082-.053.2.2 0 0 1-.043-.085v-1.68a.76.76 0 0 0-.103-.338.8.8 0 0 0-.248-.26.86.86 0 0 0-.48-.141h-.353l-1.766.439a.22.22 0 0 1-.147 0l-1.14-1.298a.924.924 0 0 0-1.309 0l-1.143 1.298a.22.22 0 0 1-.147 0h.002l-1.87-.46h-.224a.85.85 0 0 0-.486.142.8.8 0 0 0-.246.26.76.76 0 0 0-.103.336v1.68a.2.2 0 0 1-.042.086.2.2 0 0 1-.08.054l-1.706.599a.84.84 0 0 0-.503.27.78.78 0 0 0-.2.519q0 .181.082.334l.995 1.394a.15.15 0 0 1 .029.09c0 .05-.01.064-.03.09l-.996 1.398a.72.72 0 0 0 .002.663.8.8 0 0 0 .19.289.8.8 0 0 0 .3.185l1.71.601q.048.016.081.053a.2.2 0 0 1 .043.085v1.68a.76.76 0 0 0 .104.338q.092.157.247.26a.86.86 0 0 0 .486.141h.35l.643-.14v7.372l3.179-3.995 3.053 3.995v-7.372l.644.16h.245a.85.85 0 0 0 .486-.142.8.8 0 0 0 .247-.258.76.76 0 0 0 .103-.337v-1.68a.2.2 0 0 1 .04-.086.2.2 0 0 1 .082-.054l1.706-.6a.85.85 0 0 0 .357-.156.8.8 0 0 0 .243-.297z"
    />
    <Path
      fill="#000054"
      d="M0 .863V25.08h16l-.22-.101a2.295 2.295 0 0 1-.98-1.75v-.168H2V2.881h28v20.18h-2.86v.162a2.3 2.3 0 0 1-.972 1.752l-.168.104h6V.863z"
    />
    <Path
      fill="#E58CA5"
      d="M14.865 12.958c.006-.371.097-.736.265-1.064.169-.328.409-.609.702-.82a.4.4 0 0 1 .169-.005H6.053v2.076h8.812zm-2.01 2.263H6.054v2.075h6.683a2.12 2.12 0 0 1-.093-1.737.63.63 0 0 1 .213-.338M6.054 6.918h19.892v2.076H6.053z"
    />
  </Svg>
);
const Memo = memo(SvgCertificate);
export default Memo;
